module.exports = __webpack_public_path__ + "static/image_thank-you-for-your-support-a096a66b86b8a0a2effe440d54223bd6.png";